/* global productObj */

// NPM
/* Load npm scripts here */

// VENDOR
/* Load vendor modules here */

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';

// HELPERS
/* Load helpers here */
import { wishlistHandler } from 'helpers/wishlist/wishlist';
import { stickyElement } from 'helpers/sticky/sticky';

// COMPONENTS
/* Load components here */
import { attributeInfoPopup } from 'components/attribute-info-popup/attributeInfoPopup';

// PAGE
/* load page specific scripts */

import BoughtTogether from './partials/boughtTogetherproducts';
import Bundles from './partials/bundles';
import TileCalculator from './partials/tileCalculator';
import VariantSelector from './partials/variantSelector';
import AddToCart from './partials/addToCart';
import { productImageSlider } from './partials/images';
import PopupAddToCartButtons from './partials/popupAddToCartButtons';
import { VideoThumbSlider } from './partials/videoThumbSlider';
import { anchors } from './partials/anchors';
import { stickyBlock } from 'components/stickyBlock/stickyBlock';
import ProductReviews from './partials/productReviews';

// The quotation form validation stack (zod + libphonenumber) is heavy, only
// load it once the visitor interacts with the form
const initRequestQuotation = () => {
    const form = document.querySelector('#product-to-quotation-form');
    if (!form) {
        return;
    }

    form.addEventListener(
        'focusin',
        () => {
            import('./partials/requestQuotationProduct').then(({ requestQuotationProduct }) => {
                requestQuotationProduct.init();
            });
        },
        { once: true }
    );
};

defaultBundle();
VideoThumbSlider();
anchors.init();
PopupAddToCartButtons.init();
BoughtTogether.init();
Bundles.init();
TileCalculator.init(); //initialize tile calculator
VariantSelector.init();
attributeInfoPopup.init();
wishlistHandler.init();
productImageSlider();
initRequestQuotation();
stickyElement('#product-images');
stickyBlock('.add-to-cart-button [name="addProductToCartForm"]');
ProductReviews.init();

// ACTIVATE ADD TO CART
AddToCart.addAjaxData();

window.addEventListener('DOMContentLoaded', function () {
    if (productObj && productObj.showPopup) {
        AddToCart.showAddedToCartPopup();
    }
});
